import React, { useState } from 'react'
import { Table, Button, Form, Modal, Input, Avatar, message } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'

import styled from 'styled-components'

import PropTypes from 'prop-types'
import InstrumentForm from './InstrumentForm'

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledInput = styled(Input)`
  width: 256px;
`

const Instruments = ({
  instruments,
  addInstrumentHandler,
  updateInstrumentHandler,
  deleteInstrumentHandler
}) => {
  const [form] = Form.useForm()
  const [formForUpdate] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [instrumentItem, setInstrumentItem] = React.useState(null)
  const [updateModal, setUpdateModal] = React.useState(false)
  const [deleteModal, setDeleteModal] = React.useState(false)

  const [searchInstrumentname, setSearchInstrumentname] = React.useState(null)

  const [listInstruments, setListInstruments] = React.useState(null)

  const [file, setFile] = useState(null)
  const fileRef = React.useRef()

  React.useEffect(() => {
    const descriptiveInstruments = instruments.map(instrument => {
      return {
        id: instrument.id,
        nameKZ: instrument.nameKZ,
        nameRU: instrument.nameRU,
        nameEN: instrument.nameEN,
        descriptionKZ: instrument.descriptionKZ,
        descriptionRU: instrument.descriptionRU,
        descriptionEN: instrument.descriptionEN,
        status: instrument.status,
        photo: instrument.photo,
        index: instrument.index
      }
    })
    let searchArray = descriptiveInstruments

    if (searchInstrumentname) {
      searchArray = searchArray.filter(instrument => {
        return (
          instrument.nameKZ?.toLowerCase().includes(searchInstrumentname) ||
          instrument.nameRU?.toLowerCase().includes(searchInstrumentname)
        )
      })
    }
    setListInstruments(searchArray)
  }, [instruments, searchInstrumentname])

  const columns = [
    {
      title: '',
      width: '1%',
      render: item => (
        <div
          style={{
            background: item.status === 'active' ? '#44FB82' : '#D4D4D4',
            height: '60px',
            width: '20px',
            margin: '-10px'
          }}
        ></div>
      )
    },
    {
      title: '',
      dataIndex: 'index',
      width: '1%'
    },
    {
      title: 'Фото',
      width: '5%',
      render: item => {
        return (
          <>
            <Avatar shape="square" size={64} src={item.photo} />
          </>
        )
      }
    },
    {
      title: 'Название(каз)',
      dataIndex: 'nameKZ',
      width: '30%'
    },
    {
      title: 'Название(рус)',
      dataIndex: 'nameRU',
      width: '30%'
    },
    {
      title: 'Название(англ)',
      dataIndex: 'nameEN',
      width: '30%'
    },
    {
      title: 'Действие',
      width: '20%',
      render: (text, item) => (
        <>
          {/* <span>
          <Link to={`/instruments/${item.id}`}>Редактировать</Link>
        </span> */}
          <span>
            <Button
              type="link"
              onClick={() => {
                formForUpdate.resetFields()
                setUpdateModal(true)
                setInstrumentItem(item)
              }}
            >
              Редактировать
            </Button>
            <Button
              danger
              type="link"
              onClick={() => {
                setDeleteModal(true)
                setInstrumentItem(item)
              }}
            >
              Удалить
            </Button>
          </span>
        </>
      )
    }
  ]

  return (
    <>
      <Table
        dataSource={listInstruments}
        columns={columns}
        rowKey={item => item.id}
        title={() => (
          <StyledHeaderContainer>
            <StyledInput
              prefix={<SearchOutlined />}
              placeholder="Название"
              onChange={e => {
                setSearchInstrumentname(e.target.value.toLowerCase())
              }}
            />
            <Button type="primary" onClick={() => setModalVisible(true)}>
              <PlusOutlined /> Новый инструмент
            </Button>
          </StyledHeaderContainer>
        )}
      />
      <Modal
        open={modalVisible}
        title="Новый инстурмент"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
          setFile(null)
          fileRef.current.value = null
        }}
        onOk={() => {
          if (file !== null) {
            addInstrumentHandler(form, setModalVisible, file, setFile, fileRef)
          } else {
            message.error('Пожалуйста, выберите Изображение')
          }
        }}
      >
        <InstrumentForm
          setFile={setFile}
          file={file}
          form={form}
          fileRef={fileRef}
        />
      </Modal>
      {updateModal && (
        <Modal
          open={updateModal}
          onCancel={() => {
            setUpdateModal(false)
            setFile(null)
            fileRef.current.value = null
          }}
          onOk={() => {
            updateInstrumentHandler(
              formForUpdate,
              instrumentItem.id,
              setUpdateModal,
              file,
              setFile,
              fileRef
            )
          }}
        >
          <InstrumentForm
            form={formForUpdate}
            nameKZ={instrumentItem.nameKZ}
            nameRU={instrumentItem.nameRU}
            nameEN={instrumentItem.nameEN}
            descriptionKZ={instrumentItem.descriptionKZ}
            descriptionRU={instrumentItem.descriptionRU}
            descriptionEN={instrumentItem.descriptionEN}
            photo={instrumentItem.photo}
            index={instrumentItem.index}
            status={instrumentItem.status}
            fileRef={fileRef}
            setFile={setFile}
          />
        </Modal>
      )}
      {deleteModal && (
        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false)
          }}
          onOk={() =>
            deleteInstrumentHandler(instrumentItem.id, setDeleteModal)
          }
        >
          <h3>
            Вы действительно хотите удалить {instrumentItem.nameKZ} -{' '}
            {instrumentItem.nameRU} ?
          </h3>
        </Modal>
      )}
    </>
  )
}

Instruments.propTypes = {
  instruments: PropTypes.arrayOf(PropTypes.object).isRequired,
  addInstrumentHandler: PropTypes.func.isRequired,
  updateInstrumentHandler: PropTypes.func.isRequired
}

export default Instruments
